import React from 'react';
import classnames from 'classnames';
import { history } from 'umi';
import COSDocPreviewer, { NavigatorToolbar } from '@gp/components/COSDocPreviewer';
import CommonNoAuthPageAccess from './CommonNoAuthPageAccess';
import { getBIDSTencentQCouldMassage } from '@sg/services/cos';
import { ENV } from '@home/_config/config';
import type { IBaseProps } from '@home/types/common';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { STRATEGIC_STORAGE_KEY } from '@sg/constants/storageKeys';

interface IInDevProjectsDocPreviewerProps extends IBaseProps {
  // 预览文档的cos的存储的key
  doc_key: string;
  doc_name?: string;
  doc_suffix?: string;
  item_id?: string | number; // Project unified_id for project selection restoration
  project_id?: string | number; // accept project_id param from other callers (fallback if item_id is undefined)
  cos_domain?: string; // COS config domain from URL params (for reusing previewer across different sections)
  scroll_target?: 'notes' | 'gr_management'; // Which section to scroll to after navigating back
}

// Require login to view documents (ensures watermark is always applied)
const getAuth = async (): Promise<boolean> => {
  const userName = sessionStorage.getItem('userName');
  // Only allow access if user is logged in (has userName)
  return !!userName;
};

const InDevProjectsDocPreviewer: React.FC<IInDevProjectsDocPreviewerProps> = (props) => {
  const {
    style,
    className,
    doc_key: docKey,
    doc_name: docName = '',
    doc_suffix: docSuffix = '',
    item_id: itemIdProp,
    project_id: projectIdProp,
    cos_domain: cosDomain,
    scroll_target: scrollTarget = 'gr_management', // Default to gr_management for backward compatibility
  } = props;

  // Prefer item_id, fallback to project_id (some callers use project_id)
  const itemId = itemIdProp ?? projectIdProp;

  console.log(
    'InDevProjectsDocPreviewer received item_id:',
    itemIdProp,
    'project_id:',
    projectIdProp,
    'resolved itemId:',
    itemId,
    'cos_domain:',
    cosDomain,
    'scroll_target:',
    scrollTarget
  );

  const handleNavigatorClick = () => {
    // Store scroll indicator in sessionStorage based on scroll_target
    if (itemId) {
      if (scrollTarget === 'notes') {
        storage.setSessionStorageItem(STRATEGIC_STORAGE_KEY.INDEV_NOTES_ID, 'true');
      } else {
        storage.setSessionStorageItem(STRATEGIC_STORAGE_KEY.INDEV_GR_MANAGEMENT_ID, 'true');
      }
    }
    console.log('InDevProjectsDocPreviewer navigating back with item_id:', itemId, 'scroll_target:', scrollTarget);
    
    // Navigate back with project_id in URL (but no scrollTo param)
    const urlParams = itemId 
      ? `tab=studio&subtitle=projects&project_id=${itemId}`
      : 'tab=studio&subtitle=projects';
    
    history.replace(`/strategic/home?${urlParams}`);
  };

  // 全球加速，预发布和正式
  const controlledEnv = ['pre', 'pro'];
  const isUseAccelerate = controlledEnv.includes(ENV);

  // Path for this previewer type - use cos_domain from URL if provided, otherwise default
  const cosPath = cosDomain || 'gate_review_material,mgmt/studio/in_dev/gr_management';

  return (
    <div style={style} className={classnames('dbs-in-dev-projects-doc-previewer', className)}>
      <COSDocPreviewer
        docKey={docKey}
        docName={docName}
        docSuffix={docSuffix}
        cosOptions={{
          useAccelerate: isUseAccelerate,
          baseCOSConfigFetcher: () => getBIDSTencentQCouldMassage(cosPath),
          authorizationFetcher: (_options?: any) => getBIDSTencentQCouldMassage(cosPath),
        }}
        getAuthParams={{}}
        getAuth={getAuth}
        toolbar={<NavigatorToolbar title="Back to In Dev Projects" onNavigatorClick={handleNavigatorClick} />}
        noAuth={<CommonNoAuthPageAccess />}
      />
    </div>
  );
};

export default InDevProjectsDocPreviewer;

